/**
 * Theme entry: loads global APIs + Blinkit-style location modal + first-visit prompt.
 */
import './skipp-location-global.js';
import * as Pref from './skipp-location-preference.js';
import * as UL from './skipp-user-location.js';
import { initSkippLocationModal } from './skipp-location-modal.js';

function migrateLegacyPreference() {
  if (Pref.getLocationSetPreference() !== null) return;
  const u = UL.getUserLocation();
  if (u?.city?.trim()) Pref.markLocationConfirmed();
}

function boot() {
  const el = document.getElementById('enhanced-location-modal');
  migrateLegacyPreference();
  if (!el) return;
  try {
    initSkippLocationModal(el);
  } catch (err) {
    console.error('[Skipp] Location modal init failed. Inline fallback opener still works.', err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

function shouldAutoOpenLocationModal() {
  try {
    const path = (window.location.pathname || '').toLowerCase();
    if (path.includes('/cart') || path.includes('/checkout')) return false;
    const u = UL.getUserLocation();
    if (u && String(u.city || '').trim()) return false;
    return true;
  } catch {
    return true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(async () => {
    try {
      const path = (window.location.pathname || '').toLowerCase();
      if (path.includes('/cart') || path.includes('/checkout')) return;
      const modal = document.getElementById('enhanced-location-modal');
      const r = await UL.promptBrowserGeolocationAndApplyLocation({
        expressDeliveryText: modal?.dataset?.deliveryText,
        nextDayDeliveryText: modal?.dataset?.nextDayText,
      });
      if (r.ok) Pref.markLocationConfirmed();
    } catch {
      /* ignore */
    }
  }, 120);

  setTimeout(() => {
    if (!shouldAutoOpenLocationModal()) return;
    if (typeof window.openEnhancedLocationModal !== 'function') return;
    const isProduct = window.__SKIPP_PAGE_TYPE__ === 'product';
    window.openEnhancedLocationModal(isProduct ? { enforce: true } : {});
  }, 450);

  setTimeout(async () => {
    try {
      if (typeof window.SkippUserLocation === 'undefined') return;
      if (Pref.getLocationSetPreference() !== 'true') return;
      const u = window.SkippUserLocation.getUserLocation();
      if (u && u.city) return;
      if (sessionStorage.getItem('skipp_loc_ip_bootstrap_v2')) return;
      sessionStorage.setItem('skipp_loc_ip_bootstrap_v2', '1');
      const modal = document.getElementById('enhanced-location-modal');
      await window.SkippUserLocation.setUserLocationFromIP({
        expressDeliveryText: modal?.dataset?.deliveryText,
        nextDayDeliveryText: modal?.dataset?.nextDayText,
      });
    } catch {
      /* ignore */
    }
  }, 1400);
});
